/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Create_TitleInputs */



/**
* | output |
* | --- |
* | "Create New Issue" |
*
* @param {Manual_Qc_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_create_title = /** @type {((inputs?: Manual_Qc_Create_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Create_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer un nouvel incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Problem erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый выпуск")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nuevo problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい問題を作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मुद्दा बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo problema")
	return /** @type {LocalizedString} */ ("Create New Issue")
});